import { string } from 'yup';

const email = string().email('Please enter a valid email').max(255, 'Email must be 255 characters or less').required('Please enter a email');

export { email };
